import { render } from "./file-archived.vue?vue&type=template&id=dceb83c2"
import script from "./file-archived.vue?vue&type=script&lang=js"
export * from "./file-archived.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__